import t from "react";
import { Link as r, install as e, RouterProvider as o, Outlet as n } from "mobx-little-router-react";
import { createBrowserHistory as u, createHashHistory as i, createMemoryHistory as c } from "history";

function s(e) {
  return t.createElement(r, e);
}

var a;

function p() {
  return a;
}

function f(t, r, o) {
  return void 0 === r && (r = {}), new Promise(function (n, s) {
    var f, h;
    return f = function (t, r) {
      var e = function e() {
        return t.context ? Object.assign({}, t.context(), r) : r;
      };

      switch (t.type) {
        case "hash":
          return {
            history: i(),
            routes: t.routes,
            getContext: e
          };

        case "memory":
          return {
            history: c(),
            routes: t.routes,
            getContext: e
          };

        default:
          return {
            history: u(),
            routes: t.routes,
            getContext: e
          };
      }
    }(t, r), a = function (t) {
      return e(t);
    }(f), o(function (t) {
      t.prototype.router = p();
    }), (h = a, new Promise(function (t) {
      return h.start(t);
    })).then(function (t) {
      try {
        return n({
          router: a,
          history: f.history
        });
      } catch (t) {
        return s(t);
      }
    }.bind(this), s);
  }.bind(this));
}

var h = function (r) {
  function e() {
    r.apply(this, arguments);
  }

  return r && (e.__proto__ = r), (e.prototype = Object.create(r && r.prototype)).constructor = e, e.prototype.render = function () {
    return t.createElement(o, {
      router: this.props.router
    }, t.createElement(n, null));
  }, e;
}(t.Component);

export { s as Link, f as boot, p as getRouter, h as PoaApp };